import { createFileRoute } from '@tanstack/react-router';
import ContactPage from '../../views/dashboard-contacts/contact';

export const Route = createFileRoute('/dashboard/contacts_/$uuid')({
  component: ContactPage,
});
